"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ix = exports.clearAcCache = exports.ac = exports.ax = exports.CC = exports.CS = void 0;
var style_1 = require("./style");
Object.defineProperty(exports, "CS", { enumerable: true, get: function () { return __importDefault(style_1).default; } });
var style_cache_1 = require("./style-cache");
Object.defineProperty(exports, "CC", { enumerable: true, get: function () { return __importDefault(style_cache_1).default; } });
var ax_1 = require("./ax");
Object.defineProperty(exports, "ax", { enumerable: true, get: function () { return __importDefault(ax_1).default; } });
var ac_1 = require("./ac");
Object.defineProperty(exports, "ac", { enumerable: true, get: function () { return __importDefault(ac_1).default; } });
Object.defineProperty(exports, "clearAcCache", { enumerable: true, get: function () { return ac_1.clearCache; } });
var css_custom_property_1 = require("./css-custom-property");
Object.defineProperty(exports, "ix", { enumerable: true, get: function () { return __importDefault(css_custom_property_1).default; } });
//# sourceMappingURL=index.js.map